import React from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import RouteContext from './modules/routes'

/*
 * "ResizeObserver loop completed with undelivered notifications" is a benign
 * browser notice, not a failure: the spec defines it as the browser saying it
 * deferred some resize callbacks to the next frame. Nothing breaks and no state
 * is lost, but it reaches window.onerror, so the dev-server overlay renders it
 * as a full-screen "Uncaught runtime errors" panel. Any component that observes
 * its own size can emit it — the Gantt on the roadmap does, in several places.
 *
 * It cannot be filtered from a window 'error' listener here: webpack-dev-server
 * registers its own listener when it is injected, which is before this bundle
 * runs, so it always fires first and stopImmediatePropagation never reaches it.
 *
 * So prevent the condition instead. The notice is emitted when an observer
 * callback changes layout during the same delivery cycle it was called in;
 * running callbacks on the next animation frame moves that work out of the
 * cycle. Costs one frame of latency on resize-driven layout, which is not
 * perceptible, and is the standard workaround for this notice.
 */
if (typeof window.ResizeObserver === 'function') {
    const NativeResizeObserver = window.ResizeObserver

    window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => {
                    // The observer may be disconnected before the frame runs.
                    if (!Array.isArray(entries) || !entries.length) return
                    callback(entries, observer)
                })
            })
        }
    }
}

const root = document.getElementById('pms')
const react = createRoot(root)

react.render(<RouteContext />)
